import localStorageTemplates from 'common/local-storage-templates';
import { getFromLocalStorage } from 'utils/saveToLocalStorage';

export default isSessionActive => {
  const isActive = getFromLocalStorage(localStorageTemplates.widgetSessionActive) === 'true';

  return isActive;
};
